/**
 * Challenge card – create challenge CTA card.
 * Composed by challengeCard.styles.ts.
 */

import { Platform } from 'react-native';
import { makeBoxShadow } from '../../shared/helpers/shadowStyles.helper';
import type { Theme } from '../../theme/getTheme';

export function getChallengeCardCreateStyles(theme: Theme): Record<string, object> {
  return {
    createCard: {
      borderRadius: 12,
      paddingVertical: 12,
      paddingHorizontal: 12,
      marginVertical: 4,
      minHeight: 132,
      borderWidth: 1,
      backgroundColor: theme.primary + '22',
      borderColor: theme.primary + '80',
      justifyContent: 'center',
      ...(Platform.OS === 'web'
        ? makeBoxShadow({
            shadowColor: theme.primary,
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.08,
            shadowRadius: 4,
          })
        : {
            shadowColor: theme.primary,
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.08,
            shadowRadius: 4,
            elevation: 2,
          }),
      ...(Platform.OS === 'web' && { cursor: 'pointer' as const }),
    },
    createCardHover: {
      backgroundColor: theme.primary + '44',
      borderColor: theme.primary + 'CC',
    },
    createCardRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 4,
    },
    createCardIconWrap: {
      width: 36,
      height: 36,
      borderRadius: 18,
      backgroundColor: theme.primaryLight ? `${theme.primaryLight}35` : theme.primary + '40',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 8,
    },
    createCardText: {
      fontSize: 17,
      fontWeight: '700',
      color: theme.primary,
    },
    createCardChevron: {
      marginLeft: 6,
    },
  };
}
